import { mapState, mapMutations } from 'vuex'
import { isEqual } from 'lodash';
import { createDebouncedSave } from '@core_mixins/perInstanceDebouncedSave'
import * as ih from '@core_utils/util'
import DFAttachedFileURL from '@core_components/client/components/subs/elements/DFAttachedFileURL.vue'
import { generateSubcomponentDataBy } from '@core_utils/subComponent/subComponent';
import { getSubFilesInfo } from '@core_utils/api/file_api.js'

export const SubComponentMixin = {
    name: 'sub-component-mixin',
    components: {
        'df-attached-file-url': DFAttachedFileURL
    },
    props: {
        // question_code: {
        //     type: String,
        //     reuqired: true,
        //     default: 'GHG'
        // },
        company_id: {
            type: Number,
            reuqired: true 
        },
        company_name: {
            type: String,
            reuqired: true 
        },
        campaign_id: {
            type: Number,
            reuqired: true 
        },
        sub_id: {
            type: [Object, Number],
            required: false,
            default: null
        },
        sub_init_id: {
            type: [Object, Number],
            required: false,
            default: null
        },
        sub_type: {
            type: String,
            required: true,
            default: 'text_input'
        },
        label: {
            type: String,
            default: null
        },
        sub_code: {
            type: String,
            required: true,
            default: 'ghg_policy'
        },
        sub_name: {
            type: [String, Object],
            default: null
        },
        sub_name_e: {
            type: [String, Object],
            default: null
        },
        sub_name_c: {
            type: [String, Object],
            default: null
        },
        sub_description: {
            type: [String, Object],
            default: null
        },
        sub_description_e: {
            type: [String, Object],
            default: null
        }, 
        sub_description_c: {
            type: [String, Object],
            default: null
        }, 
        sub_info: {
            type: [String, Object],
            default: null
        },
        sub_info_e: {
            type: [String, Object],
            default: null
        }, 
        sub_info_c: {
            type: [String, Object],
            default: null
        }, 
        sub_condition: {
            type: Object,
            default: () => ({ value: null, text: null, })
        },
        sub_data_header: {
            default: () => ({}) 
        },
        sub_data_contents: {
            default: () => ({ structure: [], result: [] })
        },
        sub_priority: {
            type: [String, Number],
            default: ''
        },
        sub_parent: {
            type: [String, Object],
            default: null
        },
        sub_child: {
            type: Array,
            default: () => ([])
        },
        has_pipeline: {
            type: Boolean,
            default: false
        },
        view_pipe_line: {
            type: Boolean,
            default: true
        },
        headers: {
            type: Boolean,
            default: true
        },
        tags: {
            type: Array,
            default: () => ([])
        },
        is_disabled_by_parent: {
            type: Boolean,
            default: false
        },
        preview: {
            type: Boolean
        },
        previous: {
            type: Boolean
        },
        audit_mode: {
            type: Boolean,
            default: false
        },
        is_final_sub_component: {
            type: Boolean,
            default: false
        },
        print_mode: {
            type: Boolean,
            default: false
        },
        no_answers: {
            type: Boolean,
            default: false
        },
        skip_info: {
            type: Boolean,
            default: false
        },
        is_edit_page: {
            type: Boolean, 
            default: false
        },
        last_save_state: {
            type: String,
            default: 'not_saved'
        }
    },
    data () {
        return {
            file: null,
            files: [],
            file_names: [],

            uploaded_file: {
                url: '',
                name: ''
            },

            is_visible_by_pipeline: true,
            prev_sub_info: {
                is_prev_version: false,
                sub_code: null,
                label: null,
                question_info: {
                    question_name: null,
                    question_name_c: null,
                    question_name_e: null,
                    question_code: null,
                }
            },

            file_placeholder:'',
            save_state: 'not_saved',

            validation_comment: '',
            validation_icon: '',
            validation_style: 'ih-validation-saved',

            mode: this.$t('파일 또는 URL 유형선택'),

            is_visible: false,

            url_temp: 'http://',
            file_temp: null,

            child_subs: [],
            score_result: 0,

            is_loaded: false,
            previous_sub: {},

            not_applicable: '',
            original_sub_data_contents: {},

            // 상세입력 모달은 원본이 아니라 이 값을 고친다 — '확인' 때만 반영·저장 (취소하면 버린다)
            modal_draft: '',
            // 답변(result)에는 남아 있는데 서버에 없는 첨부 파일 이름 (file_URL2) — 답변은 고치지 않고 화면에만 알린다
            missing_files: [],
        }
    },
    computed: {
        ...mapState(['question_in_progress', 'view_mode', 'admin_mode', 'response_code']),
        sub_code_label (){
            return this.label ?? this.sub_code
        },
        question_code () {
            return this.$route.params.question_code ?? this.$route.query.question_code 
        },
        save_company_name () {
            return ih.resolveSaveCompanyName(this.$store.state.campaign_in_progress, this.$route.query, this.company_name)
        },
        is_locked () {
            if (this.question_in_progress.is_completed === 'true') return true
            else return false
        },
        question_subs () {
            return this.$store.state.questions.subs
        },
        is_indicate_description () {
            var indicate_temp = this.sub_description
            if (indicate_temp) {
                indicate_temp.replace(/(\s*)/g,"")
                if (indicate_temp === '') return false
                else return true
            } else {
                return false
            }
        },
        is_disabled_attached () {
            return this.is_locked
                || this.is_disabled_by_condition
                || this.is_disabled_by_parent
                || (this.$options.name !== "df-file-url2" && !this.sub_id)
                || !this.is_visible_by_pipeline
        },
        is_disabled_by_na () {
            return this.sub_data_contents.result == '해당없음'
        },
        is_disabled_by_condition () {
            if(!this.is_sub_condition_activated) return false
            else {
                var x = this.sub_condition.value
                if( x === 'false' ||
                    x === false ||
                    x === '' ||
                    x === undefined ||
                    x === 'undefined' ||
                    x === '아니오' ||
                    x === 0 ||
                    x === '0' ||
                    x === null )
                { return  true }

                else return false
            }
        },
        is_sub_condition_activated () {
            const _sub_condition = typeof this.sub_condition === 'string'
                ? JSON.parse(this.sub_condition)
                : this.sub_condition
            
            if (_sub_condition.text) {
                if (_sub_condition.text !== '') {
                    if (!_sub_condition.value) {
                        this.$set(_sub_condition, 'value', false)
                    }
                    return true
                } else {
                    return false
                }
            } else {
                this.$set(_sub_condition, 'text', '')
                return false
            }
        },
        badge_var(){          
            if (this.sub_priority=='기초'){
                return 'basic'
            }
            else if (this.sub_priority=='심화'){
                return 'advance'
            }
            else if (this.sub_priority=='잠재'){
                return 'emerging'
            }            
        },
        locale(){
            return this.$i18n.locale
        },
        lang_append () {
            const pair_append_locale = {
                'kr': '',
                'ko': '',
                'en': '_ea',
                'ca': '_ca'
            }
            return pair_append_locale[this.$i18n.locale]
        },
        button_title () {
            return this.$t(`평가정보`)
        },
        pipeline_title () {
            return this.$t(`이 문항은 답변할 필요가 없습니다.`)
        },
        file_modal_title () {
            return this.$t(`URL / 파일 첨부하기`)
        },
        form_placeholder () {
            return this.$t(`여기로 끌어오거나, 클릭하여 파일을 찾으세요.`)
        },
        na_state(){
            if (this.sub_data_header.enable_na && this.not_applicable === true && !this.sub_data_contents.na_reason) {
                return false
            } else {
                return null
            }
        },
        required_attachment(){
            return this.sub_data_header?.required_attachment === true
        },
        required_answer(){
            return this.sub_data_header?.required_answer === true
        },
        enable_na_label () {
            return !this.sub_data_header?.enable_na_label
                ? this.$t('해당없음')
                : this.$i18n.locale === "ko"
                    ? this.sub_data_header?.enable_na_label
                    : this.$i18n.locale === "en"
                        ? this.sub_data_header?.enable_na_label_ea
                        : this.sub_data_header?.enable_na_label_ca
        },
        form_id () {
            return this.print_mode
                ? `print-sub-${this.sub_type}-${this.sub_init_id}-cpn-${this.company_id}`
                : `sub-${this.sub_type}-${this.sub_init_id}-cpn-${this.company_id}`
        }
    },
    beforeDestroy () {
        // 800ms 대기 중에 문항을 이동/언마운트해도 마지막 입력이 유실되지 않게 내보낸다
        this.debouncedSave.flush()
        this.$EventBus.$off('pipeline-updated', this.handlePipelineUpdated)
    },
    watch: {
        // 화면 문구는 반응형(showTranslation·$t)이라 다시 그릴 필요가 없다 — 저장 상태 문구만 새 언어로 바꾼다
        locale(){
            this.applySaveStateMessage(this.save_state)
        },
        save_state (_save_state) {
            this.applySaveStateMessage(_save_state)
        },
        'sub_data_contents.result': {
            deep: true,
            immediate: true,
            handler (_updated_result) {
                if (this.sub_data_header.enable_na === true) {
                    if (_updated_result == '해당없음') {
                        this.not_applicable = true
                    } else if([[], ''].includes(_updated_result) && this.save_state !== 'saved') {
                        this.not_applicable = ''
                    } else {
                        this.not_applicable = false
                    }
                }
            }
        }
    },
    async created () {
        // await 보다 먼저 만들어야 한다 — 입력이 들어오기 전에 인스턴스 전용 debounce 가 있어야 함
        this.debouncedSave = createDebouncedSave(this)
        this.save_state = this.last_save_state

        // 같은 문항의 다른 답변이 파이프라인을 바꾸면(Questions.vue 가 알림) 문항 전체를 다시 만들지 않고 이 sub 만 갱신한다.
        // 인쇄용·과거답변 인스턴스는 화면 입력과 무관하니 듣지 않는다
        if (!this.print_mode && !this.previous) {
            this.$EventBus.$on('pipeline-updated', this.handlePipelineUpdated)
        }

        if (this.has_pipeline && this.view_pipe_line) {
            // 파이프라인 가시성 조회 실패가 컴포넌트 렌더 자체를 막지 않도록 격리한다.
            // 여기서 throw 되면 아래 original_sub_data_contents 스냅샷과 initiateData() 가
            // 통째로 실행되지 않아, 답변이 있는 문항이 빈칸으로 보인다.
            try {
                await this.checkPipelineVisibility()
            } catch (error) {
                // raw error 를 그대로 찍으면 axios error.config 에 담긴 Authorization 헤더가
                // 콘솔에 노출되므로, sub_code 와 HTTP status 만 남긴다.
                const _status = error && error.response ? error.response.status : 'network'
                console.error(`[SubComponent] checkPipelineVisibility 실패 (sub_code: ${this.sub_code}, status: ${_status})`)
            }
        }


        this.original_sub_data_contents = ih.deepCopy(this.sub_data_contents)
        await this.initiateData()
    },
    methods: {
        ...mapMutations('questions', ['update_sub']),
        applySaveStateMessage (_save_state) {
            if (_save_state === 'saving') {
                this.validation_comment = this.$t(`저장 중 입니다.`)
                this.validation_icon = 'hourglass'
                this.validation_style = 'ih-validation-saving'
            } else if (_save_state === 'saved') {
                this.validation_comment = this.$t(`저장 되었습니다`)
                this.validation_icon = 'check'
                this.validation_style = 'ih-validation-saved'
            } else if (_save_state === 'resaved') {
                this.validation_comment = this.$t(`변경 저장 되었습니다`)
                this.validation_icon = 'check'
                this.validation_style = 'ih-validation-resaved'
            } else if (_save_state === 'failed') {
                this.validation_comment = this.$t(`저장하지 못했습니다. 다시 시도해주세요`)
                this.validation_icon = 'exclamation-triangle'
                this.validation_style = 'ih-validation-failed'
            }
        },
        // 예전에는 문항 전체를 다시 만들어(created 재실행) 얻던 갱신 — 파이프라인 표시와 자식 sub 만 다시 읽는다
        async handlePipelineUpdated () {
            try {
                if (this.has_pipeline && this.view_pipe_line) {
                    await this.checkPipelineVisibility({ keep_pending_input: true })
                }
                if (this.sub_child && this.sub_child.length && !this.print_mode && !this.no_answers) {
                    await this.readChildSubs()
                }
            } catch (error) {
                const _status = error && error.response ? error.response.status : 'network'
                console.error(`[SubComponent] 파이프라인 갱신 실패 (sub_code: ${this.sub_code}, status: ${_status})`)
            }
        },
        async initiateData() {
            try {
                this.is_loaded = false
                
                if (!this.print_mode && !this.no_answers) {
                    // 차일드 컴포넌트가 존재하는 경우 정보 가져옴
                    if (!!this.sub_child && this.sub_child.length) {
                        await this.readChildSubs()
                    }
                    
                    if (this.sub_type === 'file_URL2') {
                        await this.getFilesFromServer()
                    }
                }
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    await this.common_401_error_handling()
                } else {
                    // 실패한 호출을 같은 파라미터로 재시도해봐야 동일하게 실패할 뿐이므로 재호출하지 않는다.
                    // (기존에는 readChildSubs / getFilesFromServer 를 그대로 다시 불렀다.)
                    // raw error 로깅은 axios error.config 의 Authorization 헤더를 노출하므로 status 만 남긴다.
                    const _status = error && error.response ? error.response.status : 'network'
                    console.error(`[SubComponent] initiateData 실패 (sub_code: ${this.sub_code}, status: ${_status})`)
                }
            } finally {
                this.$emit('sub-load-finished', this.sub_code)
                this.is_loaded = true
            }
        },
        async getFilesFromServer () {
            if(!this.sub_data_contents.result || this.sub_data_contents.result === '해당없음') {
                console.log('저장될 파일이 제대로 지정되지 않았음')
                return
            }

            const res = await getSubFilesInfo({
                campaign_id : this.campaign_id,
                company_id : this.company_id,
                sub_code : this.sub_code
            })

            // 서버(S3·DFFiles)에 없는 파일은 답변 값을 바꾸지 않는다 — 예전처럼 이름에 '(오류)' 를 붙이면 다시 저장될 때 그대로 남았다
            const _missing = []
            this.sub_data_contents.result.forEach((v,i) => {
                if (v.type === 'URL') return
                const _file_info = res.find(fileInfo => fileInfo.filename === v.filename)
                if (!_file_info) {
                    _missing.push(String(v.filename).replace(/(\(오류\))+$/, ''))
                    return
                }
                this.sub_data_contents.result[i].file_link = _file_info.savepath
            })
            this.missing_files = _missing
        },
        async readChildSubs () {
            try {
                this.child_subs = []
                let temp_subs = []

                // company_id / campaign_id 는 백엔드 read_sub 의 필수 파라미터다.
                // 빠뜨리면 이 조회는 항상 실패해 자식 sub 가 표시되지 않는다.
                const _res_child_subs = await this.$axios.get('/subs', {
                    params: {
                        sub_codes: this.sub_child.join(','),
                        company_id: this.company_id,
                        campaign_id: this.campaign_id
                    }
                })
                if (_res_child_subs.data && _res_child_subs.data.length) {
                    _res_child_subs.data.forEach(child_subs => {
                        temp_subs.push({
                            ...generateSubcomponentDataBy(child_subs),
                            question_code: this.question_code
                        })
                    });
                }

                this.child_subs = temp_subs
            } catch (error) {
                this.common_error_handling(error)
            }
        },
        async radioSave (update_pipeline = true) {
            // update_pipeline: default: true 만약 element에서 업데이트 한 것이면, pipeline 체크다시 안함
            // change_mode
            this.markInputChanged()
            this.save_state = 'saving'
            this.debouncedSave(update_pipeline)
        },
        // 입력·저장이 일어날 때마다 올린다 — 그 사이에 시작된 파이프라인 조회 응답은 답변을 덮지 않는다
        markInputChanged () {
            this._input_rev = (this._input_rev || 0) + 1
        },
        textInputSave(update_pipeline, is_blur = false) {
            if(typeof update_pipeline == "undefined") {
                update_pipeline = false
            }

            this.markInputChanged()
            this.save_state = 'saving'
            this.debouncedSave(update_pipeline, {text_input_save: true, is_blur})
        },
        getSaveScope () {
            return {
                company_id: this.$route.query.cpn ?? this.company_id,
                company_name: this.save_company_name,
                campaign_id: this.$route.query.cmp ?? this.campaign_id,
                question_code: this.question_code
            }
        },
        makeMode(new_mode){
            this.mode = new_mode
        },
        // 상세입력 모달 '확인': 예약된 자동저장을 버리고 draft 를 원본에 넣어 바로 저장한다
        async applyModalDraft (target, key) {
            this.debouncedSave.cancel()
            this.$set(target, key, this.modal_draft)
            await this.dbSave()
        },
        retrySave () {
            if (this.save_state !== 'failed') return
            this.save_state = 'saving'
            this.dbSave(false, {})
        },
        async dbSave (update_pipeline = true, options = {}, scope = this.getSaveScope()) {
            try {
                this.markInputChanged()
                this.save_state = 'saving'
                const response = await this.$axios.post('/subs', {
                    sub_id: this.sub_id,
                    sub_init_id: this.sub_init_id,
                    ...scope,
                    sub_code: this.sub_code,
                    sub_data_contents: this.sub_data_contents,
                    score_result: this.score_result
                })
                
                
                if(options.text_input_save) {
                    if(isEqual(this.sub_data_contents, response.data.sub_data_contents)){
                        this.$store.commit('questions/update_sub', response.data)
                    }
                    else if(options.is_blur){
                        this.$store.commit('questions/update_sub', response.data)
                    }
                }
                else {
                    this.$store.commit('questions/update_sub', response.data)
                }
                
                this.save_state = 'resaved'

                if (response.data.pipeline_updated && update_pipeline) { 
                    this.$emit('update-pipeline', this.save_state)
                } // 파이프라인 변경 되었을 경우 Question 전체를 다시 그림
            } catch (error) {
                // 401 은 _axios 인터셉터가 처리한다. 그 외(네트워크/타임아웃/4xx/5xx)는 입력값을 유지한 채
                // 문항 아래에 실패와 재시도를 표시한다 (화면 이동 없음).
                if (error.response && Number(error.response.status) === 401) return
                this.save_state = 'failed'
            }
        },
        handleSubmit(){
            return true
        },
        toggleVisible(){
            this.is_visible = !this.is_visible
        },
        deleteDataContents(item,index){
            var checkItem = this.files[index]
            if (item.file_url_key !== checkItem.file_url_key){
                console.log("Wrong item & index")
                return
            }
        
            this.files.splice(index,1)
            this.files.forEach((fileInfo,index) => fileInfo.file_url_key = index+1)
        },
        addFileToSubDataContents (items) {
            //remove duplicated files between item & this.files
            items.forEach((item,index)=>{
                if (this.files.some(fi => fi.filename == item.name)){
                    console.log(`${item.name} alreay in this.files`)
                    return 
                }
                if (item) {
                    let new_file_item = {
                        type: 'file',
                        filename: item.name,
                        file_link: item.name,
                        file_url_key: this.files.length+1+index,
                        file : item
                    }
                    this.files.push(new_file_item)
                }
            })
            this.$nextTick(() => {
                this.file_temp = null
            })
        },
        updateStore(sub_data_contents, sub_condition){
            let new_sub = {
                sub_code: this.sub_code, 
                sub_name: this.sub_name, 
                sub_name_e: this.sub_name_e,
                sub_name_c: this.sub_name_c,
                sub_description: this.sub_description,
                sub_description_e: this.sub_description_e, 
                sub_description_c: this.sub_description_c, 
                sub_info: this.sub_info, 
                sub_info_e: this.sub_info_e,
                sub_info_c: this.sub_info_c,
                sub_condition: sub_condition, 
                sub_type: this.sub_type, 
                sub_data_header: this.sub_data_header,
                sub_data_contents: sub_data_contents,
                sub_priority: this.sub_priority,
                sub_parent: this.sub_parent, 
                sub_child: this.sub_chid,
                save_state: this.save_state,
                score_result: this.score_result
            }
            this.$store.commit('questions/update_sub',new_sub)
        },
        handleUpdateParentContents(sub_data_contents, sub_code){
            let idx = this.child_subs.findIndex(item => { return item.sub_code == sub_code })
            if (idx > -1) {
                let new_sub = { ...this.child_subs[idx] }
                new_sub.sub_data_contents = sub_data_contents
                this.child_subs.splice(idx, 1, new_sub)
            } else {
                console.log('차일드 서브에서 못찾음')
            }
        },
        // keep_pending_input: 저장 대기·실패 중인 입력이 있으면 서버 답변으로 덮지 않고 표시 여부만 바꾼다
        async checkPipelineVisibility ({ keep_pending_input = false } = {}) {
            // 연달아 불리면 마지막 호출만 반영한다 (늦게 온 앞 응답이 최신 상태를 덮지 않게)
            const _seq = this._pipeline_seq = (this._pipeline_seq || 0) + 1
            const _input_rev = this._input_rev
            let campaign_id = this.$route.query.cmp ?? this.$route.query.campaign_id
            let company_id = this.$route.query.cpn ?? this.$route.query.company_id
            let company_name = this.save_company_name
            
            if(this.previous){
                campaign_id = this.campaign_id;
                company_id = this.company_id;
                company_name = this.company_name;
            }
            
            const response = await this.$axios.get('/check_pipeline_visibility', {
                params: {
                    sub_code: this.sub_code,
                    campaign_id,
                    company_id,
                    company_name,
                }
            })
            
            if (_seq !== this._pipeline_seq) return

            if (response.data && response.data.pipeline_sub_info) {
                this.prev_sub_info = response.data.pipeline_sub_info
                this.prev_sub_info.is_prev_version = this.previous
            }


            let _res_subs = null
            if(this.no_answers){
                _res_subs = await this.$axios.get('/subs_init', {
                    params: { sub_codes: this.sub_code }
                })
            }
            else {
                _res_subs = await this.$axios.get('/subs', {
                    params: { sub_codes: this.sub_code, company_id: this.company_id, campaign_id: this.campaign_id }
                })
            }
            
            // 응답이 비면(sub_code 미존재 등) data[0] 이 undefined 이고,
            // generateSubcomponentDataBy 의 JSON.parse(JSON.stringify(undefined)) 가 SyntaxError 를 던진다.
            // created() 훅에서 호출되므로 그대로 두면 컴포넌트 전체가 렌더되지 않는다.
            const _first_sub = _res_subs && _res_subs.data && _res_subs.data.length
                ? _res_subs.data[0]
                : null

            if (_seq !== this._pipeline_seq) return

            // 조회 사이에 입력·저장이 있었거나 저장 대기·실패 중이면 덮지 않는다 — 저장 응답이 이 sub 를 서버 값으로 맞춘다
            const _has_pending_input = keep_pending_input
                && (_input_rev !== this._input_rev || ['saving', 'failed'].includes(this.save_state))
            if (_first_sub && !_has_pending_input) {
                this.$store.commit('questions/update_sub', generateSubcomponentDataBy(_first_sub))
            } else if (!_first_sub) {
                console.warn(`[SubComponent] /subs 응답이 비어 sub 갱신을 건너뜁니다 (sub_code: ${this.sub_code})`)
            }

            this.is_visible_by_pipeline = response.data.visibility
            
        },
        async handleAttachmentSave (new_attachment) {
            const _new_attachment = new_attachment.map((file, index) => ({ ...file, file_url_key: index + 1 }))
            this.sub_data_contents.attachment = _new_attachment
            await this.radioSave()
        },
        async get_file() {
            try {
                let got_file = { url: '', name: '' }
                const response = await this.$axios({
                    method: 'GET',
                    url: '/get_file',
                    params: {
                        requested_file: this.sub_data_contents.file_name,
                        company_name: this.$store.getters.getCompanyName,
                        sub_code: this.sub_code
                    },
                    responseType: 'blob', // important
                })
                got_file['url'] = window.URL.createObjectURL(response.data);
                got_file['name'] = this.sub_data_contents.file_name
                return got_file
            } catch (error) {
                console.log(error)
                if (error.response) {
                    this.common_error_handling(error)
                }
            }
        }
    }
}
